import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';
import { callApi } from './loadingSaga';
import Api from '../api/schoolAutoSuggestApi';
import * as Actions from '../actions/schoolAutoSuggestActions';

export function* getSchoolNames(action) {
  yield put(Actions.setLoadingSchoolNames(true));
  const { values } = yield select((state) => state.form[action.payload.formName]);
  let grade = 0;
  if (values.student !== undefined
      && values.student.grade !== undefined
      && values.student.grade !== 'お選びください'
      && values.student.grade !== ''
  ) {
    grade = Number.parseInt(values.student.grade, 10);
  } else if (values.parent_status !== undefined
      && values.parent_status.student_statuses_attributes !== undefined
      && values.parent_status.student_statuses_attributes[0].student_attributes !== undefined
      && values.parent_status.student_statuses_attributes[0].student_attributes.grade !== undefined
      && values.parent_status.student_statuses_attributes[0].student_attributes.grade !== 'お選びください'
      && values.parent_status.student_statuses_attributes[0].student_attributes.grade !== ''
  ) {
    grade = Number.parseInt(values.parent_status.student_statuses_attributes[0].student_attributes.grade, 10);
  }

  const schoolNames = yield call(callApi, Api.getSchoolNames, action.payload.value, grade);
  yield put(Actions.setSchoolNames(schoolNames.map((x) => ({ value: x, label: x }))));
  yield put(Actions.setLoadingSchoolNames(false));
}

export default function* studentSaga() {
  yield takeLatest(Actions.SAGA_GET_SCHOOL_NAMES, getSchoolNames);
}
